import { DEFAULT_MINIMUM_RETRY_DELAY_WHEN_THROTTLED } from '../../const';
import type { RetryDelayFunction } from '../../types';
import { defaultGetDelayFromNumberOfAttempts } from './defaultGetDelayFromNumberOfAttempts';

export const defaultRetryDelay: RetryDelayFunction = ({
  numberOfFailedAttempts,
  response,
}) => {
  const isThrottled = response.status === 429;

  // Wait at least a minimum amount of time (currently 6 seconds) when throttled
  const minDelay = isThrottled ? DEFAULT_MINIMUM_RETRY_DELAY_WHEN_THROTTLED : 0;

  const calculatedDelay = defaultGetDelayFromNumberOfAttempts({
    numberOfFailedAttempts,
  });

  return Math.max(minDelay, calculatedDelay);
};
